import Service from './Service';

/**
 * Classe utilizada para tratar regras de negócio e manipular o retorno dos webservices
 */
class ChangelogService extends Service {
  async consultar () {
    let changes = [];
    let result = await this.getChangelogApi().consultar();
    changes = result.listaChanges;
    changes.map(element => {
      element.message = element.message.replace(/^(feat|fix)./gim, '');
      element.message = element.message.trimStart();
      element.message = element.message.replace(/^\w/, c => c.toUpperCase());
    });
    return changes;
  }

  async contar () {
    let numero = 0;
    numero = await this.getChangelogApi().contar();
    return numero;
  }

  async updateCookie () {
    return this.getChangelogApi().atualizarCookie();
  }
}

export default ChangelogService;
